<template>
  <div
    role="radiogroup"
    class="tw-flex tw-flex-col tw-gap-4"
    data-testid="sf-radio-group"
  >
    <!-- The type prefix keeps 1 and '1' apart: both stringify to one key. -->
    <SfRadio
      v-for="option in options"
      :key="`${typeof option.value}:${option.value}`"
      :model-value="modelValue"
      :value="option.value"
      :label="option.label"
      :description="option.description"
      :note="option.note"
      :name="groupName"
      :disabled="disabled || option.disabled"
      @update:model-value="emit('update:modelValue', option.value)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, useId } from 'vue'

import SfRadio from '@app/shared/vue/components/sf-radio/sf-radio.vue'
import type {
  SfRadioOption,
  SfRadioValue,
} from '@app/shared/vue/components/sf-radio/types'

defineOptions({ name: 'SfRadioGroup' })

interface Props {
  options: SfRadioOption[]
  modelValue?: SfRadioValue
  name?: string
  disabled?: boolean
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    'update:modelValue': [value: SfRadioValue]
  }>()

const uid = useId()

const groupName = computed(() => props.name ?? `sf-radio-group-${uid}`)
</script>
